import React, { useEffect, useState } from "react";
//import { Chart } from "react-google-charts";
import { format, startOfWeek, endOfWeek } from "date-fns";
import client from "../../api";
import { useParams } from "react-router-dom";
import { notifyError } from "../../helper";
import BlockLoader from "../BlockLoader";
import ComboChart from "./ComboChart";

const CampaignTimeline = (props) => {
    const {contactList} = props;
    const api = client();
    const { campaignID } = useParams("");
    const [blockLoader,setBlockLoader] = useState(true);
    const [timeLineData, setTimeLineData] = useState({});
    const [graphData, setGraphData] = useState([]);

    // Fixed color set for consistency
    const colors = [
        "#FF5733", "#FF5733", "#FF5733", "#FF5733",
        "#FF5733", "#FF5733", "#FF5733", "#FF5733"
    ];

    // Function to format "YYYY-MM-DD" to "DD/MM"
    const formatDate = (isoDate) => {
        const dateObj = new Date(isoDate);
        return `${dateObj.getDate().toString().padStart(2, "0")}/${(dateObj.getMonth() + 1).toString().padStart(2, "0")}`;
    };

    // Function to get current week's Sunday and Saturday
    const getCurrentWeekDates = () => {
        const today = new Date();
        const sunday = startOfWeek(today, { weekStartsOn: 0 }); // Sunday
        const saturday = endOfWeek(today, { weekStartsOn: 0 }); // Saturday
        return {
            // Format to "YYYY-MM-DD"
            startDate: format(sunday, "yyyy-MM-dd"),
            endDate: format(saturday, "yyyy-MM-dd")
        };
    };

    // Function to prepare chart data
    // const prepareGraphData = (graphData) => {
    //     const data = [
    //         ["Dates", "Email Sent", { role: "style" }], // Static header row
    //         ...graphData.map((item, index) => [formatDate(item.date), item.count, colors[index % colors.length]])
    //     ];
    //     setGraphData(data); // Store in state
    // };

    const prepareGraphData = (_obj) => {
        const firstRow = _obj[Object.keys(_obj)[0]];
        let headers = [];
        let count = 1;
         Object.keys(firstRow).forEach((item,i)=> {            
            if(item === '_date'){
                headers.push('Date');
            } else if(item === 'contacts_added'){
                headers.push('Contacts Added');
            } else if(item === 'email'){
                headers.push('Initial');
            } else {
                headers.push(`Follow up ${count}`);
                count++;
            }
         });
        const dataArr = Object.keys(_obj).map((date,i) => {
          const entry = _obj[date];          
          const row = [entry._date];
                  
          Object.keys(entry).forEach(key => {
            if (key !== '_date') {
              row.push(entry[key]);
            }
          });      
          return row;
        });
        
        setGraphData([headers,...dataArr]);        
      };

    useEffect(() => {

        const { startDate, endDate } = getCurrentWeekDates();
        // Call campaign timeline API
        const getCampaignTimeLineData = async () => {
            try {
                setBlockLoader(true);
                const response = await api.post("/v1/campaign/timeline", {
                    campaign_id: campaignID,
                    list_id: contactList
                });
                if (response.status === 200 || response.status === 201) {
                    const data = response.data.campaignTimeline;
                    setBlockLoader(false);
                    setTimeLineData(data);
                }
            } catch (error) {
                setBlockLoader(false);
                console.log("error.message", error);
                if (error.status === 400) notifyError("Bad Request. Unable to fetch Campaign Timeline data. Please try again");
            }
        };
        getCampaignTimeLineData();

        // Call campaign timeline graph API
        const getCampaignTimeLineGraphData = async () => {
            try {
                const response = await api.post("/v1/campaign/timeline/graph", {
                    campaign_id: campaignID,
                    list_id: contactList,
                    start_date: startDate,
                    end_date: endDate
                });
                if (response.status === 200 || response.status === 201) {
                    const data = response.data.campaignTimelineGraph;
                    prepareGraphData(data);
                }
            } catch (error) {
                console.log("error.message", error);
                if (error.status === 400) notifyError("Bad Request. Unable to fetch Campaign Timeline Graph data. Please try again");
            }
        };
        getCampaignTimeLineGraphData();
    }, [contactList]);
    
    return (
        <div className="timeline-wrap">
            {blockLoader ? <div className="timeline-section bg-white"><BlockLoader /></div> : (
                <div className="timeline-section">
                    <div className="timeline-graph"><ComboChart data={graphData} /> </div>
                    {/* <div className="timeline-graph">
                        {graphData.length > 1 ? (
                            <Chart
                                chartType="ColumnChart"
                                data={graphData}
                                width="80%"
                                height="400px"
                                legendToggle
                            />
                        ) : (
                            <p>Loading Chart...</p>
                        )}
                    </div> */}
                    <div className="timeline-list-wrap">
                        <div className="timeline-list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>List</th>
                                        <th>Added Date</th>
                                        <th>Recipients</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {timeLineData.list_details?.length ? (
                                        timeLineData.list_details.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.name}</td>
                                                <td>{format(row.created_at, "MMM dd, yyyy hh:mm:ss aa")}</td>
                                                {/* <td></td> */}
                                                <td>{row.total_contacts}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>Timeline data is not available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CampaignTimeline;